import { render, staticRenderFns } from "./UserDetailCard.vue?vue&type=template&id=7cf66d3c&"
import script from "./UserDetailCard.vue?vue&type=script&lang=js&"
export * from "./UserDetailCard.vue?vue&type=script&lang=js&"
import style0 from "./UserDetailCard.vue?vue&type=style&index=0&id=7cf66d3c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports